"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadingMediaItemCard = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
function UploadingMediaItemCard(_a) {
    var _b, _c, _d;
    var mediaItem = _a.mediaItem, mediaContext = _a.mediaContext;
    var _js = mediaContext._js;
    var stepText = function (mediaItem) {
        if (mediaItem.step === 'uploading') {
            return _js('Uploading');
        }
        else if (mediaItem.step === 'processing') {
            return _js('Processing');
        }
        return _js('Complete');
    };
    return (React.createElement(react_1.Card, { w: 172, minH: 200, backgroundColor: "gray.300", boxShadow: "lg", display: "flex", flexDirection: "column", justifyContent: "space-between", "aria-label": (_c = (_b = mediaItem.file) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : _js('Uploading file'), role: "listitem" },
        React.createElement(react_1.Flex, { minH: "125px", justifyContent: "center", alignItems: "center" }, mediaItem.progress === null ? (React.createElement(react_1.Flex, { direction: "column" },
            React.createElement(react_1.CircularProgress, { size: '97px', isIndeterminate: true, color: "blue.500", mt: 1 }),
            React.createElement(react_1.Flex, { justifyContent: "center", alignItems: "center", backgroundColor: "transparent", h: "25px" },
                React.createElement(react_1.Text, { color: "blueGray.600" }, stepText(mediaItem))))) : (React.createElement(react_1.Flex, { direction: 'column' },
            React.createElement(react_1.CircularProgress, { size: '97px', value: Math.round(mediaItem.progress * 100), color: "blue.500", mt: 1 },
                React.createElement(react_1.CircularProgressLabel, null,
                    Math.round(mediaItem.progress * 100),
                    "%")),
            React.createElement(react_1.Flex, { justifyContent: "center", alignItems: "center", backgroundColor: "transparent", h: "25px" },
                React.createElement(react_1.Text, { color: "blueGray.600" }, stepText(mediaItem)))))),
        React.createElement(react_1.CardBody, { pl: 1, pr: 1, pb: 1 },
            React.createElement(react_1.Flex, { justifyContent: "center", alignItems: "center", backgroundColor: "white", h: "25px" },
                React.createElement(react_1.Text, { noOfLines: 1, maxW: "162px" }, (_d = mediaItem.file) === null || _d === void 0 ? void 0 : _d.name)))));
}
exports.UploadingMediaItemCard = UploadingMediaItemCard;
